import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import CheckIcon from '../../../../assets/images/CheckIcon.svg';
import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    listItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 18,
      cursor: 'pointer',
    },
    leftPart: {
      display: 'flex',
      alignItems: 'center',
    },
    listItemActive: {
      '& $listItemTitle': {
        color: colorsPalette.white,
      },
      '& $listItemCount': {
        opacity: 1,
      },
    },
    listItemTitle: {
      fontSize: 16,
      lineHeight: 1.2,
      color: colorsPalette.gray,
      marginBottom: 0,
    },
    listItemCount: {
      fontSize: 11,
      lineHeight: 1.2,
      color: colorsPalette.white,
      opacity: 0.5,
      marginBottom: 0,
    },
    checkbox: {
      position: 'absolute',
      zIndex: -1,
      opacity: 0,
      '&:checked + $checkboxLabel': {
        '&::before': {
          border: `2px solid ${colorsPalette.blue}`,
        },
        '&::after': {
          display: 'block',
        },
      },
    },
    checkboxLabel: {
      marginRight: SMALL_MARGIN,
      position: 'relative',
      cursor: 'pointer',
      '&::before': {
        content: '""',
        width: 21,
        height: 21,
        borderRadius: 5,
        border: `2px solid ${colorsPalette.gray}`,
        display: 'block',
      },
      '&::after': {
        content: '""',
        display: 'none',
        backgroundImage: `url(${CheckIcon})`,
        zIndex: 2,
        position: 'absolute',
        left: 5,
        top: 6,
        width: 12,
        height: 9,
      },
    },
    icon: {
      width: 16,
      height: 16,
      cursor: 'pointer',
      transform: 'rotate(180deg)',
      transition: 'transform 0.3s ease-out',
      marginRight: SMALL_MARGIN,
    },
    selectedIcon: {
      transform: 'none',
    },
  }),
);

export default useStyles;
